import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 15000 });

export const getSermons = () => client.get('/sermons').then((r) => r.data);
export const getSermon = (id) => client.get(`/sermons/${id}`).then((r) => r.data);
export const getEvents = () => client.get('/events').then((r) => r.data);
export const submitContact = (payload) => client.post('/contact', payload).then((r) => r.data);
export const submitVisit = (payload) => client.post('/plan-visit', payload).then((r) => r.data);
export const subscribe = (email) => client.post('/subscribe', { email }).then((r) => r.data);

export default client;
